import { render } from "./RelationshipCheck.vue?vue&type=template&id=180ecd7a&scoped=true"
import script from "./RelationshipCheck.vue?vue&type=script&lang=js"
export * from "./RelationshipCheck.vue?vue&type=script&lang=js"

import "./RelationshipCheck.vue?vue&type=style&index=0&id=180ecd7a&scoped=true&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180ecd7a"]])

export default __exports__